/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 27.04.2016.
 */

import React, {Component, PropTypes} from 'react';
import {Link} from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Classnames from 'classnames';
import DocumentTitle from 'react-document-title';

import _get from 'lodash/get';
import _at from 'lodash/at';
import _map from 'lodash/map';
import _filter from 'lodash/filter';
import _flatten from 'lodash/flatten';
import _size from 'lodash/size';
import _chunk from 'lodash/chunk';
import _isEqual from 'lodash/isEqual';
import _pull from 'lodash/pull';

import {GetCollection, AppendCollection, ClearCollection} from '../../actions/collection/actions-collection';
import {OpenProfileFor, CloseAllProfiles} from '../../actions/common/actions-common';

import {isEndOfPage, ParseResource} from '../../utils';

import Translate from '../../components/Translate';
import DivLoader from '../../components/DivLoader';
import ShowcaseRow from '../../components/ShowcaseCollection/showcase-collection-row';

class ShowcaseCollection extends Component {
  constructor(props) {
    super(props);

    this._additionalQuery = {
      genres: []
    };

    this.state = {
      title: '',
      icon: '',
      isShowGenres: false,
      genres: [],
      limit: props.startLimit,
      extendedRow: null,
      query: []
    };

    this._bindHandleEndOfPage = this._handleEndOfPage.bind(this);
  }

  componentDidMount() {

    let query = this.__parseUrlToQuery(_get(this.props, 'url'));

    this.props.GetCollection(query, _get(this.props, 'url'));

    if (this.props.isDynamic) {
      window.addEventListener('scroll', this._bindHandleEndOfPage);
    }

    if (this.props.globalProfile && this.props.id !== this.props.globalProfile) {

      this._onCollapseRow();
    }
  }

  componentWillReceiveProps(newProps) {

    if (_get(this.props, 'url') !== _get(newProps, 'url') || !_isEqual(this.props.categories, newProps.categories)) {
      window.removeEventListener('scroll', this._bindHandleEndOfPage);
      if (newProps.isDynamic) {
        window.addEventListener('scroll', this._bindHandleEndOfPage);
      }

      this.setState({limit: newProps.startLimit, extendedRow: null, extendedCol: null});

      let query = this.__parseUrlToQuery(_get(newProps, 'url'), newProps);

      this.props.ClearCollection(_get(this.props, 'url'));
      this.props.GetCollection(query, _get(newProps, 'url'));
    }

    if (newProps.globalProfile && newProps.id !== newProps.globalProfile) {

      this._onCollapseRow();
    }
  }

  componentWillUnmount() {
    if (this.props.isDynamic) {
      window.removeEventListener('scroll', this._bindHandleEndOfPage);

    }

    this.props.ClearCollection(_get(this.props, 'url'));
  }

  __parseUrlToQuery(url = '', props = this.props) {

    let parse = url.split('+');

    let categories = [];
    let genres = [];
    let views = [];
    let sortBy = [];

    parse.forEach((item) => {

      if (item[0] === 'C') {
        categories = _map(item.split('C')[1].split(','), (c) => +c);

        categories = _filter(props.categories, (c) => {
          return categories.indexOf(c.id) !== -1;
        });

        genres = _flatten(_map(categories, 'genres'));

        this.setState({'genres': _pull(genres, undefined)});
      }

      if (item[0] === 'V') {
        if (item === 'VLV') {
          views = ['live', 'vod'];
        }
        if (item === 'VL') {
          views = ['live'];
        }
        if (item === 'VV') {
          views = ['vod'];
        }
      }

      if (item[0] === 'S') {
        if (item === 'SL') {
          sortBy = 'er_lcn';
        }
      }
    });

    //Find icons and titles for showcase or use category
    let findedItem = null;
    _get(Config, 'menu', []).forEach(function (item) {
      let res = ParseResource(item.app_url);

      if (res.categories && res.categories === _map(categories, 'extid').join(',')) {

        findedItem = item;
      }
    });

    if (!findedItem) {
      _get(Config, 'sections', []).forEach(function (item) {
        let res = ParseResource(item.app_url);

        if (res.categories && res.categories === _map(categories, 'extid').join(',')) {

          findedItem = item;
        }
      });
    }

    if (findedItem) {
      this.setState({
        title: findedItem.title,
        icon: findedItem.icon
      });
    } else {

      console.warn('Title & Icon set from categories');
      this.setState({title: _map(categories, 'title').join(' & ')});
    }

    categories = _map(categories, 'id');
    genres = _map(this._additionalQuery.genres, 'id');

    let limit = props.startLimit;

    this.setState({'query': {categories, genres, views, limit, sortBy}});

    return {categories, genres, views, limit, sortBy};
  }

  _handleEndOfPage() {

    if (!this.props.isPreview && isEndOfPage()) {
      this._showMore();
    }
  }

  _toggleGenres() {

    if (this.state.isShowGenres) {
      this._clearGenre();
    }

    if (this.state.genres.length) this.setState({isShowGenres: !this.state.isShowGenres});
  }

  _selectGenre(genre) {
    this.setState({limit: this.props.startLimit, extendedRow: null, extendedCol: null});

    this._additionalQuery.genres = [genre];

    let query = this.__parseUrlToQuery(_get(this.props, 'url'));

    this.props.GetCollection(query, _get(this.props, 'url'));
  }

  _clearGenre() {
    if (!this._additionalQuery.genres.length) return;

    this.setState({limit: this.props.startLimit, extendedRow: null, extendedCol: null});

    this._additionalQuery.genres = [];

    let query = this.__parseUrlToQuery(_get(this.props, 'url'));

    this.props.GetCollection(query, _get(this.props, 'url'));
  }

  _showMore() {

    if (!this.props.inProgress && !this.props.isEnd) {
      this.props.AppendCollection({...this.state.query, limit: this.props.nextLimit, offset: _size(this.props.assets)}, _get(this.props, 'url'));
    } else if (this.props.isEnd) {
      if (this.props.isDynamic) {
        window.removeEventListener('scroll', this._bindHandleEndOfPage);
      }
    }
  }

  _onExtendRow(row, col) {

    this.setState({extendedRow: row, extendedCol: col});
    this.props.OpenProfileFor(this.props.id);
  }

  _onCollapseRow() {

    this.setState({extendedRow: null, extendedCol: null});
  }

  _renderGenres() {

    return _chunk(this.state.genres, '4').map((group) => {
      return (<ul>
        {group.map((genre) => {
          let genreClasses = Classnames({
            'select-genre hover': true,
            'color-grey': _get(this.state, 'query.genres', []).length && _get(this.state, 'query.genres', []).indexOf(genre.id) === -1,
            'b': _get(this.state, 'query.genres', []).length && _get(this.state, 'query.genres', []).indexOf(genre.id) !== -1
          });

          return (<li key={'genre_' + genre.id} onClick={this._selectGenre.bind(this, genre)}><a className={genreClasses} id={'genre_' + genre.id}>{genre.title}</a></li>);
        })}
      </ul>);
    });
  }

  _renderAssetRows() {
    if (!_get(this.props, 'assets')) {
      return null;
    }

    return _chunk(this.props.assets, '9').map((chunk, index) => {

      return <ShowcaseRow
        key={`row_${this.props.url}_${index}`}
        assets={chunk}
        row={index}
        onExtendRow={this._onExtendRow.bind(this)}
        isExtend={this.state.extendedRow === index}
        sel_row={this.state.extendedRow}
        sel_col={this.state.extendedCol}
      />
    });
  }

  render() {
    return (
      <div className="asset-showcase" style={{position: 'relative'}}>
        {!this.props.isPreview && <DocumentTitle title={(this.state.title[0] === '$' ? Translate.translator(this.state.title.replace('$', '')) : this.state.title)} />}
        { (this.state.isShowGenres) &&
        <div className="genres bg-black radius">
          <a className="ico-close genres-close pointer" onClick={this._toggleGenres.bind(this)}><Translate content="close" /></a>
          {this._renderGenres()}
        </div>
        }
        <div id="showcase-header" className="blocks-row clearfix">
          <ul className="menu block-3 radius bg-black">
            <li className="block-1">
              <a className="pad-lr hover pointer">
                <span className="icon">
                   <img alt="" src={this.state.icon || `/images/${Config.white_skin ? 'white' : 'black'}/ico-genres.png`} />
                </span>
              </a>
            </li>
            <li className="block-1" onClick={this.props.CloseAllProfiles.bind(this)}>
              <Link to={'/showcase/' + _get(this.props, 'url')} className="pad-lr hover container pointer">
                <span><strong>{this.state.title[0] === '$' ? <Translate content={this.state.title.replace('$', '')} /> : this.state.title}</strong></span>
              </Link>
            </li>
            {!this.props.isPreview && <li className="block-1 col-last genres-open">
              <a className="pad-lr hover pointer" onClick={this._toggleGenres.bind(this)}>
              <span className="block-note-2 p+">
                <strong><img alt="" src={`/images/${Config.white_skin ? 'white' : 'black'}/dots.png`} /></strong>
                <span className="pv-"><Translate content="genres" /></span>
              </span>
              </a>
            </li>}
          </ul>
        </div>
        <div id="showcase-row-container">
          {this._renderAssetRows()}
        </div>
        { (this.props.inProgress) &&
        <div className="profile-container">
          <div id="showcase_row" style={{height: '132px', position: 'relative'}}>
            <div className="blocks-row clearfix showcase-row radius" style={{height: '100%'}}>
              <DivLoader loading={this.props.inProgress} />
            </div>
          </div>
        </div>
        }
        { (!this.props.inProgress && !_size(this.props.assets) ) && <div id="showcase-empty-container">
          <div className="ui dimmer visible active radius">
            <div className="content">
              <div className="center">
                <h2 className="ui inverted icon header">
                  <Translate content="empty_section" />
                </h2>
              </div>
            </div>
          </div>
        </div>
        }
        {( !this.props.isPreview && !this.props.inProgress && !this.props.isEnd && _size(this.props.assets)) && <div id="showcase-more" className="blocks-row clearfix">
          <ul className="menu block-1 radius bg-black">
            <li className="block-1 col-last">
              <a className="hover pointer" id="blocks-asset-more" onClick={this._showMore.bind(this)}>
                <span className="block-note p+"><strong><img src={`/images/${Config.white_skin ? 'white' : 'black'}/dots.png`} alt="" /></strong> <Translate content={'more_menu_items'} /> </span>
              </a>
            </li>
          </ul>
        </div> }
      </div>
    );
  }
}

ShowcaseCollection.propTypes = {
  isDynamic: PropTypes.bool,
  isPreview: PropTypes.bool,
  nextLimit: PropTypes.number,
  startLimit: PropTypes.number,
  url: PropTypes.string.isRequired,

  /**
   * @connect props
   */
  inProgress: PropTypes.bool.isRequired,
  isEnd: PropTypes.bool.isRequired,
  categories: PropTypes.array.isRequired,
  assets: PropTypes.array.isRequired,
};

ShowcaseCollection.defaultProps = {
  isDynamic: true,
  isPreview: false,
  nextLimit: 18,
  startLimit: 18,
  url: '',

  /**
   * @connect props
   */
  inProgress: false,
  isEnd: false,
  categories: [],
  assets: []
};

const mapStateToProps = ({assets, collections, common: {categories, profile}}, ownProps) => {
  let collection = collections[ownProps.url] || {};
  let assetEntities = _at(assets, collection.assets || []);

  return {
    globalProfile: profile,
    assets: assetEntities,
    categories: categories,
    inProgress: !!collection.inProgress,
    isEnd: !!collection.isEnd
  }
};

const mapDispatchToProps = (dispatch) => {

  return bindActionCreators({GetCollection, AppendCollection, ClearCollection, OpenProfileFor, CloseAllProfiles}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ShowcaseCollection);



// WEBPACK FOOTER //
// ./src/containers/ShowcaseCollection/showcase-collection.js